// @module SuiteDB.SDBServiceHardwareItems.SDBServiceHardwareItems
define("SuiteDB.SDBServiceHardwareItems.SDBServiceItemsSummary.View", [
  "suitedb_sdbservicehardwareitems_sdbserviceitemssummary.tpl",
  "SuiteDB.SDBServiceHardwareItems.SDBServiceHardwareItems.Model",
  "Backbone",
], function (
  suitedb_sdbservicehardwareitems_sdbserviceitemssummary_tpl,
  SDBServiceHardwareItemsModel,
  Backbone
) {
  "use strict";

  return Backbone.View.extend({
    template: suitedb_sdbservicehardwareitems_sdbserviceitemssummary_tpl,

    initialize: function initialize(options) {
      //attributes
      this.model = SDBServiceHardwareItemsModel.getInstance();
      this.model.summaryView = this;
    },

    events: {},

    bindings: {},

    childViews: {},

    getContext: function getContext() {
      if (!this.model.summaryServices) return {};
      return {
        items: this.model.summaryServices,
      };
    },
  });
});
